import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type TagModel from 'frontend/models/tag';

interface SearchPageComponentArgs {
  tags: TagModel[];
  updateTargetAudienceQP: (value: string) => {};
  updateModalityQP: (value: string) => {};
  updatePlannedQP: (value: string) => {};
  updateIsNewQP: (value: boolean) => {};
  updateParcoursQP: (value: boolean) => {};
  updateSearchQP: (value: string | undefined) => {};
  updateDateQP: (value: string | null, key: 'start' | 'end') => {};
  updateFamiliesQP: (value: string[]) => {};
  updateTagsQP: (value: string[]) => {};
  queryParams: {
    targetAudience: string;
    families: string[];
    tags: string[];
  };
}

export default class SearchPageComponent extends Component<SearchPageComponentArgs> {
  @tracked isOpen: boolean = false;
  @tracked selectedTags: TagModel[] = [];

  constructor(owner: unknown, args: SearchPageComponentArgs) {
    super(owner, args);
  }
  @action
  updateTargetAudience(value: string) {
    this.args.updateTargetAudienceQP(value);
  }
  @action
  updateModality(value: string) {
    this.args.updateModalityQP(value);
  }
  @action
  updatePlanned(value: string) {
    this.args.updatePlannedQP(value);
  }
  @action
  updateIsNew(value: boolean) {
    this.args.updateIsNewQP(value);
  }
  @action
  updateParcours(value: boolean) {
    this.args.updateParcoursQP(value);
  }

  @action
  updateFamilies(value: string) {
    const families = this.args.queryParams.families;
    const index = families.indexOf(value);
    if (index !== -1) {
      families.splice(index, 1);
    } else {
      families.push(value);
    }
    this.args.updateFamiliesQP(families);
  }
  @action
  updateTags(value: string) {
    const tags = this.args.queryParams.tags;
    const index = tags.indexOf(value);
    if (index !== -1) {
      tags.splice(index, 1);
    } else {
      tags.push(value);
    }
    this.args.updateTagsQP(tags);
  }

  @action
  openFilters() {
    this.isOpen = !this.isOpen;
  }

  @action
  closeFilters() {
    this.isOpen = false;
  }

  @action
  updateSearch(value: string) {
    if (!value.length) {
      this.args.updateSearchQP(undefined);
    }
    this.args.updateSearchQP(value);
  }

  @action
  updateDate(key: 'start' | 'end', value: string | null) {
    if (!value) {
      this.args.updateDateQP(value, key);
      return;
    }
    this.args.updateDateQP(new Date(value).toISOString(), key);
  }

  @action
  resetFilters() {
    this.args.updateTargetAudienceQP('all');
    this.args.updatePlannedQP('all');
    this.args.updateIsNewQP(false);
    this.args.updateParcoursQP(false);
    this.args.updateModalityQP('all');
    this.args.updateDateQP(null, 'start');
    this.args.updateDateQP(null, 'end');
    this.args.updateSearchQP(undefined);
    this.args.updateFamiliesQP([]);
    this.args.updateTagsQP([]);
    this.isOpen = false;
  }
}
